import { MapPin } from 'lucide-react'
import { HtmlHTMLAttributes } from 'react'
import { Link } from 'react-router-dom'

import { useAuth } from '@/contexts'
import type { Property } from '@/models/property'

import { Button } from '../button'
import { ConservationBadge } from '../conservation'
import { LeafIcon } from '../icons/leaf'
import { Skeleton } from '../skeleton'
import { Carousel } from '../slider'

interface CardPropertyProps extends HtmlHTMLAttributes<HTMLDivElement> {
  properties: Property[] | []
}
export function NewCardProperties({ properties }: CardPropertyProps) {
  const { signed } = useAuth()
  return (
    <div className="grid h-96 w-full flex-1 grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:gap-6">
      {properties.map((prop) => (
        <div
          key={prop.id_propriedade}
          className="flex h-full w-full flex-col rounded-2xl"
        >
          <div className="relative h-full max-h-52 w-full 2xl:max-h-80">
            {/* Botão de tipo de conservação */}
            <div className="absolute left-2 top-2 z-10">
              <ConservationBadge type={prop.tipo_conservacao} />
            </div>
            {/* Botão de tipo de conservação */}

            {!prop.imagens && (
              <Skeleton className="h-52 w-full rounded-b-none rounded-t-lg object-cover 2xl:h-60" />
            )}
            {prop.imagens && prop.imagens.length > 0 ? (
              <Carousel itemsPerPage={1} spaceBetween={20}>
                {prop.imagens.map((image) => (
                  <img
                    key={image.id_img}
                    src={image.url_obj}
                    alt="Imagens da propriedade"
                    className="pointer-events-none h-52 w-full select-none rounded-t-2xl object-cover 2xl:h-80"
                  />
                ))}
              </Carousel>
            ) : (
              <Skeleton className="h-52 w-full rounded-b-none rounded-t-2xl object-cover 2xl:h-80" />
            )}
          </div>
          <div className="flex h-full space-y-5 rounded-b-2xl bg-white p-4 pt-2">
            <div className="flex flex-1 flex-col gap-2">
              <h1
                className="line-clamp-1 text-center text-lg font-bold text-bios-title sm:text-start lg:text-xl"
                data-wg-notranslate
              >
                {prop.dadosbasicos.nome_propriedade}
              </h1>
              {signed && (
                <div className="h-14">
                  <span className="line-clamp-2 text-center text-monochromatic-500 sm:text-start lg:text-lg">
                    {prop.dadosbasicos.sobre_propriedade}
                  </span>
                </div>
              )}
              <span className="flex items-center justify-center gap-2 text-base text-monochromatic-400 sm:justify-start">
                <LeafIcon className="size-6" />
                Bioma {prop.endereco.bioma}
              </span>
              <span className="flex items-center justify-center gap-2 text-base text-monochromatic-400 sm:justify-start">
                <MapPin className="size-5" />
                {prop.endereco.cidade} - {prop.endereco.estado}
              </span>
              <div className="mx-auto flex items-center justify-between sm:mx-0">
                <Link
                  data-testid={`property-link-${prop.id_propriedade}`}
                  to={`/property/${prop.id_propriedade}`}
                >
                  <Button
                    className="border-bios-primary bg-bios-primary/5 uppercase"
                    variant="outline"
                  >
                    Conheça o projeto
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
